import { useSupabaseLoader } from "../../../../../server/supabase/hooks";
import type { UseSupabaseLoaderState } from "../../../../../server/supabase/hooks/types";
import { getEffectiveDate, type UseMomentProperties } from "../../../../moment-card/types";
import { SupabaseMomentCardMomentService } from "../../../../moment/server/supabase-moment-service";

export const useEmailCommunicationMoments = (): UseSupabaseLoaderState<UseMomentProperties[]> & {
  reload: () => void;
} => {
  return useSupabaseLoader(async ({ supabase, account_id }) => {
    const oneYearAgo = new Date();
    oneYearAgo.setFullYear(oneYearAgo.getFullYear() - 1);

    const { data, error } = await new SupabaseMomentCardMomentService(supabase).getAllMoments(
      account_id,
      {
        order: [{ column: "title" }],
        filter: [
          { key: "status", operator: "neq", value: "draft" },
          { key: "status", operator: "neq", value: "archived" },
          { key: "follow_up", operator: "is", value: null },
          {
            key: "channel",
            operator: "in",
            value: '("work_email","personal_email")',
          },
          { key: "published_at", operator: "gte", value: oneYearAgo.toISOString() },
        ],
      },
    );

    if (error) throw new Error(error.message);

    return (data ?? []).sort((a, b) => {
      const aWhen = getEffectiveDate(a);
      const bWhen = getEffectiveDate(b);
      if ((aWhen === null || aWhen === undefined) && (bWhen === null || bWhen === undefined))
        return 0;
      if (aWhen === null || aWhen === undefined) return 1;
      if (bWhen === null || bWhen === undefined) return -1;
      return bWhen.localeCompare(aWhen);
    });
  }, []);
};
